
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.684 4.831c.403-.4.423-1.07.046-1.496a.96.96 0 0 0-1.317-.133l-.097.084-8 7.941a1.104 1.104 0 0 0-.084 1.452l.084.094 8 7.94a.961.961 0 0 0 1.413-.048c.35-.393.359-.995.041-1.4l-.086-.096L8.462 12l7.222-7.169Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M15.6839 4.83128C16.0869 4.43133 16.1073 3.76127 15.7295 3.33465C15.3809 2.94086 14.8148 2.89215 14.4129 3.20155L14.3161 3.28637L6.31606 11.2275C5.92475 11.616 5.8968 12.2544 6.23221 12.6786L6.31606 12.7725L14.3161 20.7136C14.719 21.1136 15.3518 21.092 15.7295 20.6653C16.0782 20.2715 16.0876 19.6703 15.7701 19.2656L15.6839 19.1687L8.462 12L15.6839 4.83128Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow-left.d4431768d3584389f693e96ba4152c60.svg"),
        {
          React: SvgArrowLeft,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      